var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.74723 11.6189C3.21188 11.6189 1.96289 10.3813 1.96289 8.8605C1.96289 7.33952 3.21188 6.10187 4.74723 6.10187C6.28238 6.10187 7.53119 7.33933 7.53119 8.8605C7.53119 10.3815 6.28238 11.6189 4.74723 11.6189ZM4.74723 6.87606C3.63867 6.87606 2.73708 7.76631 2.73708 8.8605C2.73708 9.9545 3.63867 10.8447 4.74723 10.8447C5.85541 10.8447 6.75699 9.9545 6.75699 8.8605C6.75699 7.76631 5.85541 6.87606 4.74723 6.87606Z",
    fill: "#404767",
    stroke: "#404767",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8675 19.2566H1.01178C0.453818 19.2566 0 18.8056 0 18.2512V16.985C0 14.3929 2.1296 12.2839 4.74742 12.2839C5.77697 12.2839 6.75699 12.6052 7.58071 13.2129C7.75271 13.3399 7.78938 13.5822 7.66236 13.7544C7.53535 13.9262 7.29322 13.9629 7.12103 13.8361C6.43133 13.3273 5.61064 13.0581 4.74742 13.0581C2.55658 13.0581 0.774194 14.8199 0.774194 16.985V18.2512C0.774194 18.3786 0.880796 18.4824 1.01178 18.4824H5.86769C6.08128 18.4824 6.25479 18.6557 6.25479 18.8695C6.25479 19.083 6.08128 19.2566 5.8675 19.2566Z",
    fill: "#404767",
    stroke: "#404767",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9883 18.9636H18.1326C17.919 18.9636 17.7455 18.7903 17.7455 18.5765C17.7455 18.3629 17.919 18.1894 18.1326 18.1894H22.9885C23.1195 18.1894 23.2261 18.0858 23.2261 17.9584V16.6922C23.2261 14.5267 21.4437 12.7653 19.2529 12.7653C18.3379 12.7653 17.4446 13.0804 16.7375 13.6527C16.5716 13.7871 16.3279 13.7616 16.1932 13.5955C16.0588 13.4293 16.0841 13.1855 16.2506 13.0509C17.095 12.3676 18.1612 11.9911 19.2529 11.9911C21.8705 11.9911 24.0001 14.0999 24.0001 16.6922V17.9584C24.0001 18.5126 23.5463 18.9636 22.9883 18.9636Z",
    fill: "#404767",
    stroke: "#404767",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2527 11.4277C17.7176 11.4277 16.4688 10.1902 16.4688 8.66922C16.4688 7.14823 17.7176 5.91058 19.2527 5.91058C20.7881 5.91058 22.037 7.14805 22.037 8.66922C22.037 10.1904 20.7879 11.4277 19.2527 11.4277ZM19.2527 6.68478C18.1445 6.68478 17.2429 7.57502 17.2429 8.66922C17.2429 9.76341 18.1445 10.6535 19.2527 10.6535C20.3613 10.6535 21.2629 9.76341 21.2629 8.66922C21.2629 7.57502 20.3611 6.68478 19.2527 6.68478Z",
    fill: "#404767",
    stroke: "#404767",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2538 20.5161H6.74628C6.04826 20.5161 5.48047 19.9525 5.48047 19.2596V17.4787C5.48047 13.9196 8.40486 11.0241 12.0001 11.0241C15.5953 11.0241 18.5197 13.9196 18.5197 17.4787V19.2596C18.5197 19.9525 17.9519 20.5161 17.2538 20.5161ZM12.0001 11.7985C8.83203 11.7985 6.25466 14.3468 6.25466 17.4789V19.2598C6.25466 19.5257 6.47524 19.7421 6.74628 19.7421H17.2537C17.5247 19.7421 17.7453 19.5257 17.7453 19.2598V17.4789C17.7455 14.3468 15.1681 11.7985 12.0001 11.7985Z",
    fill: "#404767",
    stroke: "#404767",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8652 10.5718C9.89269 10.5718 8.2876 8.98203 8.2876 7.02764C8.2876 5.07345 9.8925 3.48386 11.8652 3.48386C13.8381 3.48386 15.443 5.07364 15.443 7.02783C15.443 8.98222 13.8379 10.5718 11.8652 10.5718ZM11.8652 4.25805C10.3195 4.25805 9.06179 5.50062 9.06179 7.02783C9.06179 8.55524 10.3195 9.79781 11.8652 9.79781C13.4111 9.79781 14.6688 8.55524 14.6688 7.02783C14.6688 5.50062 13.4111 4.25805 11.8652 4.25805Z",
    fill: "#404767",
    stroke: "#404767",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberIcon);
export default __webpack_public_path__ + "static/media/member-icon.c5e86229d6f30c9e099e951c07eb5870.svg";
export { ForwardRef as ReactComponent };